const PAID_FINANCIAL_STATUSES = new Set([
  "AUTHORIZED",
  "PAID",
  "PARTIALLY_PAID",
]);

export type PaymentStatusLabel = "支払済" | "未払い";

export function paymentStatusLabel(
  financialStatus: string | null | undefined,
): PaymentStatusLabel {
  const normalized = (financialStatus ?? "").trim().toUpperCase();
  return PAID_FINANCIAL_STATUSES.has(normalized) ? "支払済" : "未払い";
}
